import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useGitLabNotifications } from '../hooks/useGitLabNotifications';
function loadGitLabConfig() {
    try {
        const saved = localStorage.getItem('projectmanmd-gitlab');
        if (!saved)
            return null;
        const settings = JSON.parse(saved);
        if (!settings.enabled || !settings.accessToken)
            return null;
        return {
            baseUrl: settings.baseUrl || 'https://gitlab.com',
            accessToken: settings.accessToken,
        };
    }
    catch {
        return null;
    }
}
export function Layout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [gitlabConfig, setGitlabConfig] = useState(loadGitLabConfig);
    // Reload config when localStorage changes
    useEffect(() => {
        const handler = () => setGitlabConfig(loadGitLabConfig());
        window.addEventListener('storage', handler);
        return () => window.removeEventListener('storage', handler);
    }, []);
    // Also poll for config changes within same tab
    useEffect(() => {
        const interval = setInterval(() => {
            setGitlabConfig(loadGitLabConfig());
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    useGitLabNotifications(gitlabConfig);
    return (_jsxs("div", { className: "flex h-screen overflow-hidden", children: [_jsx(Sidebar, { isOpen: sidebarOpen, onClose: () => setSidebarOpen(false) }), _jsxs("div", { className: "flex flex-col flex-1 min-w-0 overflow-hidden", children: [_jsx(Header, { onToggleSidebar: () => setSidebarOpen((prev) => !prev) }), _jsx("main", { className: "flex-1 overflow-auto p-6", children: _jsx(Outlet, {}) })] })] }));
}
//# sourceMappingURL=Layout.js.map